import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'url-search-params-polyfill';
import 'intersection-observer';

import React from 'react';
import ReactDOM from 'react-dom';

import { ThemeProvider } from '@material-ui/styles';
import App from './App';
import theme from './theme';
import 'typeface-roboto';

const rootElement = document.getElementById('root');
if (rootElement) {
  ReactDOM.render(
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>,
    rootElement
  );
}
